import dynamic from 'next/dynamic';
import { useAppTranslation } from 'hooks/use-translates';
import React, { useEffect, useState } from 'react';

const Button = dynamic(() => import('core/generic/elements/button'), {
	ssr: false,
});

export type CodeRequestButtonProps = {
    seconds?: number;
    triggerRenew?: boolean;
    onClick?: () => void;
};

export const CodeRequestButton = ({
    seconds = 30,
    triggerRenew,
    onClick,
}: CodeRequestButtonProps) => {
    const [secondsLeft, setSecondsLeft] = useState(seconds);
    const [canRequest, setCanRequest] = useState(false);
    const { t } = useAppTranslation();

    useEffect(() => {
        if (secondsLeft <= 0) {
            setCanRequest(true);
            return;
        }

        const timer = setInterval(() => {
            setSecondsLeft((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [secondsLeft]);

    useEffect(() => {
        setCanRequest(false);
        setSecondsLeft(seconds);
    }, [triggerRenew]);

    const formatSecondsToTime = (seconds: number) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(
            2,
            '0'
        )}`;
    };

    return (
        <Button
            type="button"
            label={
                canRequest
                    ? t('verification.resend_code_button_label')
                    : `${t(
                          'verification.request_new_button_label'
                      )} ${formatSecondsToTime(secondsLeft)}`
            }
            variant="ds-secondary"
            disabled={!canRequest}
            fullWidth={true}
            onClick={canRequest ? onClick : undefined}
            dimension="large"
        />
    );
};
